module.exports = __webpack_public_path__ + "static/media/pytorch.30e5f549.png";